import React from 'react'
import { Grid, Typography, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { dateFormat } from '../utils/formatter'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%'
  },
  tableHeader: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: '#333',
    borderBottom: '1px solid #ddd',
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1)
  },
  tableRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
    borderBottom: '1px solid #f0f0f0'
  },
  tableCell: {
    fontSize: '0.85rem',
    color: '#666'
  },
  tableCellValue: {
    fontSize: '0.85rem',
    color: '#333',
    fontStyle: 'italic'
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: '#333'
  }
}))

const formatDate = (date) => {
  if (!date) return ''
  return dateFormat(date)
}

const formatNumber = (value) => {
  if (!value && value !== 0) return ''
  return value.toString()
}

const ServiceRow = ({ label, date, years, months, days, classes }) => (
  <div className={classes.tableRow}>
    <div className={classes.tableCell}>{label}:</div>
    <div className={classes.tableCellValue}>{formatDate(date)}</div>
    <div className={classes.tableCellValue}>{formatNumber(years)}</div>
    <div className={classes.tableCellValue}>{formatNumber(months)}</div>
    <div className={classes.tableCellValue}>{formatNumber(days)}</div>
  </div>
)

const JobRow = ({ label, serviceDate, years, months, days, classes }) => (
  <div className={classes.tableRow}>
    <div className={classes.tableCell}>{label}:</div>
    <div className={classes.tableCellValue}>{formatDate(serviceDate)}</div>
    <div className={classes.tableCellValue}>{formatNumber(years)}</div>
    <div className={classes.tableCellValue}>{formatNumber(months)}</div>
    <div className={classes.tableCellValue}>{formatNumber(days)}</div>
  </div>
)

export default function LengthOfServiceDisplay({ data }) {
  const classes = useStyles()

  // Get the first row of data if it exists
  const rowData = data && data.length > 0 ? data[0] : {}

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {/* Length of Service Section */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h5" className={classes.sectionTitle}>
              Length of Service
            </Typography>
            
            {/* Table Header */}
            <div className={classes.tableRow}>
              <div className={classes.tableHeader}>Date</div>
              <div className={classes.tableHeader}>Years</div>
              <div className={classes.tableHeader}>Months</div>
              <div className={classes.tableHeader}>Total Days</div>
            </div>

            {/* Service Rows */}
            <ServiceRow
              label="Hire"
              date={rowData.DATE_HIRED}
              years={rowData.DATE_HIRED_YEARS}
              months={rowData.DATE_HIRED_MONTHS}
              days={rowData.DATE_HIRED_DAYS}
              classes={classes}
            />
            
            <ServiceRow
              label="Adjusted Hire"
              date={rowData.ADJ_HIRE_DATE}
              years={rowData.ADJ_HIRE_YEARS}
              months={rowData.ADJ_HIRE_MONTHS}
              days={rowData.ADJ_HIRE_DAYS}
              classes={classes}
            />
            
            <ServiceRow
              label="Anniversary"
              date={rowData.ANNIVERS_DATE}
              years={rowData.ANNIVERS_YEARS}
              months={rowData.ANNIVERS_MONTHS}
              days={rowData.ANNIVERS_DAYS}
              classes={classes}
            />
            
            <ServiceRow
              label="Seniority"
              date={rowData.SENIOR_DATE}
              years={rowData.SENIOR_YEARS}
              months={rowData.SENIOR_MONTHS}
              days={rowData.SENIOR_DAYS}
              classes={classes}
            />
          </Paper>
        </Grid>

        {/* Job Section */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h5" className={classes.sectionTitle}>
              Job
            </Typography>
            
            {/* Table Header */}
            <div className={classes.tableRow}>
              <div className={classes.tableHeader}>Service Date</div>
              <div className={classes.tableHeader}>Years</div>
              <div className={classes.tableHeader}>Months</div>
              <div className={classes.tableHeader}>Total Days</div>
            </div>

            {/* Job Row */}
            <JobRow
              label={rowData.JOB_CODE || 'job_code'}
              serviceDate={rowData.SERVICE_DATE}
              years={rowData.YEARS_IN_POSITION}
              months={rowData.MONTHS_IN_POSITION}
              days={rowData.DAYS_IN_POSITION}
              classes={classes}
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}
